// src/lib/layouts/resolveMediaMode.ts

/** Def-level mode including 'auto' (static when an image is set, video otherwise). */
export type LayoutDefMode = 'video' | 'static_image' | 'auto';

export function resolveMediaMode(
  mode: LayoutDefMode,
  config: { imageUrl?: string },
): 'video' | 'static_image' {
  if (mode === 'auto') {
    return config.imageUrl ? 'static_image' : 'video';
  }
  return mode;
}
